import { render } from "./CuratorContacts.vue?vue&type=template&id=44ecda15&scoped=true"
import script from "./CuratorContacts.vue?vue&type=script&lang=js"
export * from "./CuratorContacts.vue?vue&type=script&lang=js"

import "./CuratorContacts.vue?vue&type=style&index=0&id=44ecda15&lang=scss&scoped=true"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ecda15"]])

export default __exports__